fragment ProductFragment on Product {

    ...ProductWithoutVariationsFragment

    variations {
        ...ProductVariationFragment
    }

}